export const handleErrorsMdfe = (msgError) => {
  if (!msgError) return null;

  if (typeof msgError === "object") {
    msgError = msgError.message || JSON.stringify(msgError);
  }

  let cleanMsg = String(msgError);

  if (cleanMsg.includes("Error:")) {
    cleanMsg = cleanMsg.replace("Error:", "").trim();
  }

  if (cleanMsg.includes("ERROR_NAME")) {
    return {
      message: String(cleanMsg.split("-")[1]).trim(),
      nameError: String(cleanMsg.split("-")[0].split(":")[1]).trim()
    };
  }

  if (cleanMsg.includes("Validation failed")) {
    return {
      message: msgError?.erros ? Object.values(msgError.erros[0])[0] : "Ops... Houve algum erro de validação!",
      nameError: "Validation failed"
    };
  }

  if (cleanMsg.length > 0 && !cleanMsg.includes("Request failed with status code")) {
    return {
      message: cleanMsg,
      nameError: "BusinessError"
    };
  }

  return null;
};